import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { serviceSettingsRoute } from '../route';

import { clickToPayValidateSearchSchema } from './helpers/clickToPayValidateSearchSchema';

export const clickToPayRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/click-to-pay',
	component: lazyRouteComponent(
		() => import('./ClickToPayPage'),
		'ClickToPayPage',
	),
	validateSearch: clickToPayValidateSearchSchema,
});
